import { Option } from '@Components/types/options';
import { User } from '@Types/index';

export const transformUserOptions = (options: User[]): Option[] => {
  return options.map((user) => ({
    label: `${user.empName}/${user.occupation}`,
    value: user.empNumber,
  }));
};
